/**
 * Limited access functionality for deprecation mode
 */
export const checkUserAccess = userEmail => {
  if (userEmail) {
    const emailsList = window.config.limited_access?.emails_list || [];
    const redirectURL = window.config.limited_access?.redirect_url;
    const userHasAccess = emailsList.includes(userEmail);
    if (!userHasAccess && redirectURL) {
      window.location.replace(redirectURL);
      return;
    }
  }
}